const en = {
    views: {
        userList: {
            age: 'Age',
            name: 'Name',
            gender: 'Gender',
            country: 'Country',
            email: 'Email',
            cell: 'Cell',
            phone: 'Phone',
            actions: 'Actions',
            address: 'Address',
            donwloadTitle: 'Download CSV',
            donwloadConfirm: 'Do you want to download it?',
            userCsvName: 'Users',
            favUserCsvName: 'Fav users',
            getApiUsers: 'Get API users',
            nickname: 'Nickname',
            uploadFavUserList: 'Upload fav user list',
            noUserTitle: 'Please load data from the api',
        },
        currentUser: {
            position: 'Position: ',
            age: 'Age: ',
            name: 'Name: ',
            gender: 'Gender: ',
            country: 'Country: ',
            email: 'Email: ',
            cell: 'Cell: ',
            phone: 'Phone: ',
            actions: 'Action: ',
            address: 'Address: ',
            noUserTitle: 'Please, select a user from the table',
        },
    },
    common: {
        titles: {
            favUserTable: 'Fav Users',
            userTable: 'Users',
            home: 'Home',
            user: 'User',
            es: 'Spanish',
            en: 'English',
            translations: 'Translations',
            apiFavUserTable: 'API fav users',
        },
        notifications: {
            errorMessage: 'An error has occurred',
            uploadFavUsers: 'Fav user list uploaded',
            getUsers: 'Users loaded',
            getFavUsers: 'Fav user list loaded',
        },
    },
};

export default en;
